import type { ReactNode } from "react";

interface SectionHeaderProps {
  children: ReactNode;
  className?: string;
}

export function SectionHeader({
  children,
  className = "",
}: SectionHeaderProps) {
  return (
    <h3 className={`mb-3 text-base sm:text-lg font-medium ${className}`}>
      {children}
    </h3>
  );
}
